
import { NAVIGATE_TO_SLIDE } from "../Actions/ActionPromo";

import { Action } from "../../types/Action";

export type State = {
  promoInitialSlide: number;
};

let initialState: State = {
  promoInitialSlide: 0
};

export type IReducerPromo = (state: State, action: Action) => State;
export const ReducerPromo = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case NAVIGATE_TO_SLIDE:
      {
        return {
          ...state,
          promoInitialSlide: action.payload.index
        };
      }
    default:
      return state;

  }
};